import React from "react";
import { Box, Tooltip } from "@mui/material";

import { userTypes, editAccessOptions, designationTypes, moduleList, userRoles } from "../../utils/commonComponent/userConstant";

const settingKeyInfo = [
  {
    key: "CertificateSummaryReportPrint",
    reason: "Certificate print show/hide in certificate summary report if true else false",
  },
  {
    key: "CertificateObserVationSheetPrint",
    reason: "Certificate print show/hide in observation sheet report if true else false",
  },
  {
    key: "ObservationWitnessHistory",
    reason: "Observation witness history show/hide in observation amd certificate if true else false",
  },
  {
    key: "CertificateSummaryVertical",
    reason: "Certificate summary show/hide in vertical format if true otherswise horizontal",
  },
  {
    key: "JobRegisterCompliancesShow",
    reason: "if true then Job register compliances section show",
  },
  {
    key: "inwardCSRF",
    reason: "if true in setting then inward list show that option in editinward , list and pdf download option",
  },
];

const roleBehaviorInfo = [
  {
    role: "Tested By",
    action: "Observation sheet process and Save button enabled",
  },
  {
    role: "Reviewed By",
    action: "Certificate Review button shown",
  },
  {
    role: "Authorized By",
    action: "Authorize button shown in certificate",
  },
];

// 🔹 New info section for Access Options
export const accessInfo = [
  {
    access: "All Access",
    description:
      "Includes all permissions: view, create, edit, delete, download, copy, and save actions.",
  },
  {
    access: "Create",
    description: "Shows Create button for adding new records.",
  },
  {
    access: "Edit",
    description: "Shows Edit icon/button in the table list for updating records.",
  },
  {
    access: "Delete",
    description: "Shows Delete icon/button in the table list for removing records.",
  },
  {
    access: "Pdf Download",
    description: "Shows PDF download button in the table or page.",
  },
  {
    access: "Excel Download",
    description: "Shows Excel download button for exporting data.",
  },
  {
    access: "Copy",
    description: "Shows Copy icon/button to copy table data.",
  },
  {
    access: "Save",
    description: "Shows Save button to save or update records.",
  },
  {
    access: "Backdate Show",
    description: "Allows viewing or editing records from past dates.",
  },
  {
    access: "View",
    description: "Shows View icon/button to open or preview record details (e.g., certificate PDF).",
  },
];

// 🔹 core floe
export const coreFLow = [
  {
    access: "Inward List",
    description: "edit = edit icon show in list, Delete = icon/button in the table list, pdfDownload = for show both pdf option",
  },
  {
    access: "Datasheet List",
    description: "edit = edit icon show in list, View = view icon show in list, Job Assign btn show usertype 1,2,3 ",
  },
  {
    access: "Certificate List",
    description: "Add View = view icon show in list ,  multiple download btn show usertype 1,2,3",
  },
];


const DesignationTable = ({ tableName, tableimport }) => {
  if (!Array.isArray(tableimport)) {
    console.error(
      `Expected an array for tableimport, got: ${typeof tableimport}`
    );
    return null; 
  }
  

  return (
    <div>
      <h5 style={{ textAlign: "left" }}>
        <b>{tableName}</b>
      </h5>
      <br />
      <table>
        <thead>
          <tr>
            <th className="border border-gray-300 p-2">ID</th>
            <th className="border border-gray-300 p-2">Name</th>
          </tr>
        </thead>
        <tbody>
          {tableimport.map((item) => (
            <tr key={item.id}>
              <td className="border border-gray-300 p-2">{item.id}</td>
              <td className="border border-gray-300 p-2">
                {item?.name}
                {item?.label}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const AppInfo = () => {
  return (
    <Tooltip style={{ padding: "1rem" }}>
      <Box
        sx={{
          margin: "1rem",
          padding: "1.5rem 1rem",
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "0.5rem",
        }}
      >
        <DesignationTable tableName={"User Types"} tableimport={userTypes} />
        <DesignationTable tableName={"Roles"} tableimport={userRoles} />
        <DesignationTable
          tableName={"User Designation"}
          tableimport={designationTypes}
        />
        <DesignationTable tableName={"Modules"} tableimport={moduleList} />
        <DesignationTable
          tableName={"Access Options"}
          tableimport={editAccessOptions}
        />
      </Box>
      <Box sx={{ margin: "1rem", padding: "0.5rem 1rem", }}>
         {/* 🔹 Role Info Table */}
        <h5 className="text-left font-semibold mb-2">Role Based Behavior</h5>
        <table className="w-full border border-gray-300 border-collapse text-center text-sm">
          <thead>
            <tr>
              <th className="border border-gray-300 p-2">Role</th>
              <th className="border border-gray-300 p-2">Action / Information</th>
            </tr>
          </thead>
          <tbody>
            {roleBehaviorInfo.map((item) => (
              <tr key={item.role}>
                <td className="border border-gray-300 p-2">{item.role}</td>
                <td className="border border-gray-300 p-2">{item.action}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <br/>
         {/* 🔹 Access Permissions Info */}
        <h5 className="text-left font-semibold mb-2">Access Permissions Info</h5>
        <table className="w-full border border-gray-300 border-collapse text-center text-sm">
          <thead>
            <tr>
              <th className="border border-gray-300 p-2">Access Type</th>
              <th className="border border-gray-300 p-2">Description</th>
            </tr>
          </thead>
          <tbody>
            {accessInfo.map((item) => (
              <tr key={item.access}>
                <td className="border border-gray-300 p-2">{item.access}</td>
                <td className="border border-gray-300 p-2">{item.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <br/>
         {/* 🔹 Core Flow Info */}
        <h5 className="text-left font-semibold mb-2">Core FLow Info</h5>
        <table className="w-full border border-gray-300 border-collapse text-center text-sm">
          <thead>
            <tr>
              <th className="border border-gray-300 p-2">Access Type</th>
              <th className="border border-gray-300 p-2">Description</th>
            </tr>
          </thead>
          <tbody>
            {coreFLow.map((item) => (
              <tr key={item.access}>
                <td className="border border-gray-300 p-2">{item.access}</td>
                <td className="border border-gray-300 p-2">{item.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <br/>

       <table className="w-full border border-gray-300 border-collapse text-center text-sm">
          <thead>
            <tr>
              <th className="border border-gray-300 p-2">key</th>
              <th className="border border-gray-300 p-2">Reason</th>
            </tr>
          </thead>
          <tbody>
            {settingKeyInfo.map((item) => (
              <tr key={item.id}>
                <td className="border border-gray-300 p-2">
                  {item.key}
                </td>
                <td className="border border-gray-300 p-2">
                  {item?.reason}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <br/>
    </Tooltip>
  );
};

export default AppInfo;
